<template>
    <div class="btn-list" :class="[bemFacet]" v-bind="cmsEditHelperAttrs">
        <!-- <pre v-if="content" v-text="content"></pre> -->

        <h2 class="btn-list--title" v-if="content.title" v-html="content.title"></h2>

        <div class="btn-list--buttons">
            <ul class="u-reset grid--row btn-list--row">
                <li class="grid--col btn-list--col" v-for="(button, buttonIdx) in buttons">
                    <component class="btn-list--button"
                            :facet="content.facet"
                            :is="button.type"
                            :plugin="button">
                    </component>
                </li>
            </ul>
        </div>

        <router-link class="btn-list--link" v-if="content.link"
                :to="content.link.path"
                v-text="content.link.label">
        </router-link>
    </div>
</template>

<script>
    import bemMixin from 'vue/mixins/bem';
    import cmsPlugin from 'vue/mixins/cms/cms-plugin';


    export default {
        mixins: [
            cmsPlugin,
            bemMixin('btn-list'),
        ],
        computed: {
            buttons() {
                return this.content.buttons;
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?33806bc4